import React, { useState, useEffect } from "react";
import { collection, doc, getDoc, getDocs } from "firebase/firestore";
import { db } from "../firebase"; // Ensure Firebase is initialized
import { Box, Typography, Avatar, AvatarGroup,Badge, styled } from "@mui/material";

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: '#44b700',
    color: '#44b700',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: 'ripple 1.2s infinite ease-in-out',
      content: '""',
    },
  },
}));
const PeopleAvatarGroup = ({ eventDocId, maxAvatars = 6 }) => {
  const [attendees, setAttendees] = useState([]);

  useEffect(() => {
    if (!eventDocId) return;

    const fetchAttendees = async () => {
      try {
        const attendeesRef = collection(db, "events", eventDocId, "guests");
        const attendeesSnapshot = await getDocs(attendeesRef);
        const attendeeList = [];

        for (const attendeeDoc of attendeesSnapshot.docs) {
          const userRef = doc(db, "users", attendeeDoc.id); // Fetch user details using attendee's UID
          const userSnap = await getDoc(userRef);

          if (userSnap.exists()) {
            const userData = userSnap.data();
            attendeeList.push({
              id: attendeeDoc.id,
              displayName: userData.displayName || "Unknown",
              profileImage: userData.profileImage || "",
            });
          }
        }

        setAttendees(attendeeList);
      } catch (error) {
        console.error("Error fetching attendees:", error);
      }
    };

    fetchAttendees();
  }, [eventDocId]);

  if (!attendees.length) {
    return <Typography>No attendees yet.</Typography>;
  }

  return (
    <Box flexGrow={1} padding={2} sx={{ bgcolor: 'background.paper', borderRadius:3, }}>
      {/* <Typography variant="subtitle1" color="textPrimary">People</Typography> */}
      <AvatarGroup max={maxAvatars} sx={{display:"inline-flex"}}>
        {attendees.map((attendee) => (
          <StyledBadge
          overlap="circular"
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          variant="dot"
        >
          <Avatar key={attendee.id} src={attendee.profileImage} alt={attendee.displayName} tooltip={ attendee.displayName}>
            {!attendee.profileImage ? attendee.displayName.charAt(0) : ""}
          </Avatar>
          </StyledBadge>
        ))}
      </AvatarGroup>
    </Box>
  );
};

export default PeopleAvatarGroup;
